import React, { createContext, useContext, useState } from 'react'

const DiscoverContext = createContext()

export const useDiscover = () => useContext(DiscoverContext)

export const DiscoverProvider = ({ children }) => {
  const [discoverData, setDiscoverData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const cacheDiscoveryData = (data) => {
    setDiscoverData(data)
  }

  return (
    <DiscoverContext.Provider
      value={{ discoverData, setDiscoverData: cacheDiscoveryData, isLoading, setIsLoading }}
    >
      {children}
    </DiscoverContext.Provider>
  )
}
